import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import { messageActions } from '../../store/message'

const BASE_PATH = '/lottustech/remessaspagamentos'
const crud = build(validate, BASE_PATH)
const prefix = 'crudRemessaPagamento'

const newTypes = {
  RESET: `${prefix}reset`,
  ADD_ITEM: `${prefix}addItem`,
  SET_ITEM: `${prefix}setItem`,
  ON_CLICK_REMOVE_ITEM: `${prefix}onClickRemoveItem`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}
actions.addItem = (payload) => {
  return {
    type: types.ADD_ITEM,
    payload,
  }
}

actions.setItem = (prop, value) => {
  return {
    type: types.SET_ITEM,
    prop,
    value,
  }
}

actions.onClickRemoveItem = (payload) => {
  return {
    type: types.ON_CLICK_REMOVE_ITEM,
    payload,
  }
}

actions.gerarRemessa = (data) => {
  return (dispatch, getState) => {
    const path = BASE_PATH + `/gerar`
    return apiService
      .post(path, data)
      .then((response) => {
        dispatch(
          messageActions.messageShowMessages(
            makeMessages(['Remessa enviada com sucesso. Favor aguardar o processamento.']),
            'success'
          )
        )
        dispatch(actions.reset())
      })
      .catch((error) => {
        if (error.response) {
          const messages = error.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages]), 'error'))
        }
      })
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = ''
  if (type === 'error') {
    summary = ''
    sticky = true
  } else if (type === 'warn') {
    summary = ''
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}
export { types, actions }
